import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import "./styles/Dashboard.css";
import { ReactComponent as DashboardIcon } from "../../images/dashboard/Dashboard.svg";
import { ReactComponent as AnalyticsIcon } from "../../images/dashboard/Analytics.svg";
import { ReactComponent as TaskIcon } from "../../images/dashboard/Task.svg";
import AssessmentIcon from "../../images/dashboard/assessment.png";
import LearningIcon from "../../images/ebook.png";
import { GlobalContext } from "../../context/GlobalState";
import AssessmentTypes from "../PracticeAssessment/AssessmentTypes/AssessmentTypes";
import Updates from "./Updates";
import TaskDashboard from "./TaskDashboard";
import { useMediaQuery } from "react-responsive";
import Drawer from "../Navbar/Drawer";
import AnalyticsTypes from "../Analytics/AnalyticsTypes/AnalyticsTypes";
import { AITab, MockTab } from "../../shared/domain/cgf/tabs/Tabs";
import ExamModal from "../../shared/domain/cgf/modal/ExamModal";
import MockExamModal from "../../shared/domain/cgf/modal/MockExamModal";
import Subjects from "../../shared/domain/learning/components/SubjectList";
import { CurrentDate } from "../../shared/ui/CurrentDate";
import { cleanURLPath } from "../../shared/utils/url";
import useTab from "../../hooks/useTab";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#edfcfa",
    width: "100%",
  },
  dashboardTabStyle: {
    color: "#7F3DFF !important",
    minWidth: "100px",
    fontWeight: "medium !important",
    fontSize: "0.95em",
    "& .MuiTab-wrapper": {
      "& .resources": {
        transform: "scale(0.2)",
      },
    },
  },
  bottomSectionStyle: {
    color: "white",
    fontSize: "0.8em",
  },
  "@media screen and (max-width:472px)": {
    dashboardTabStyle: {
      minWidth: "60px",
      "& .MuiTab-wrapper": {
        fontSize: "0.8em",
      },
      "& .MuiTabs-flexContainer": {
        justifyContent: "space-evenly",
      },
    },
  },
}));

const tabList = [];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  const dashboardTab = useTab([
    "Dashboard",
    "Learning Resources",
    "Analytics",
    "Assigned Tasks",
    "Assessment",
  ]);
  const history = useHistory();
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });
  const { grade, section } = useContext(GlobalContext).userDetails;
  const {
    userDetails,
    setUserDetails,
    schoolLevelAccess,
    boardLevelAccess,
    allSubjects,
    subLoading,
  } = useContext(GlobalContext);
  const [aiStudio, setAIStudio] = useState(false);
  const [mockTest, setMock] = useState(false);
  document.title = "2xcell.in";

  const openSubject = (subject) => {
    history.push(
      `/learningresources/${cleanURLPath(subject?.subject)}/${
        subject.subjectId
      }`,
    );
  };

  const classes = useStyles();
  const theme = useTheme();

  React.useEffect(() => {
    setUserDetails({
      ...userDetails,
      selectedTab: dashboardTab.label,
      selectedPath: {
        subject: "",
        chapter: "",
        topic: "",
      },
    });
  }, [dashboardTab.label]);

  const customStyles = () => ({
    fontSize: "0.5em",
  });

  const DashboardTabs = () => (
    <Paper className={classes.root}>
      <Tabs
        value={dashboardTab.index}
        onChange={(_, index) => dashboardTab.change(index)}
        indicatorColor="primary"
        textColor="inherit"
        variant="scrollable"
        scrollButtons={"on"}
        // centered
      >
        <Tab
          label="Home"
          icon={<DashboardIcon />}
          {...a11yProps(0)}
          className={classes.dashboardTabStyle}
          styles={{ fontSize: "0.5em !important" }}
        />
        <Tab
          label="Resources"
          icon={<img src={LearningIcon} style={{ width: "26px" }} />}
          {...a11yProps(1)}
          className={classes.dashboardTabStyle}
          styles={{ fontSize: "0.5em !important" }}
        />
        <Tab
          label="Analytics"
          icon={<AnalyticsIcon />}
          {...a11yProps(2)}
          className={classes.dashboardTabStyle}
        />
        <Tab
          label="Assigned Task"
          icon={<TaskIcon />}
          {...a11yProps(3)}
          className={classes.dashboardTabStyle}
        />
        <Tab
          label="Assessment"
          icon={<img src={AssessmentIcon} />}
          {...a11yProps(4)}
          className={classes.dashboardTabStyle}
        />
        {schoolLevelAccess || boardLevelAccess ? (
          <Tab  className={classes.dashboardTabStyle} label={<AITab onClick={() => setAIStudio(true)} />} />
        ) : null}
        {schoolLevelAccess ? (
          <Tab  className={classes.dashboardTabStyle} label={<MockTab onClick={() => setMock(true)} />} />
        ) : null}
      </Tabs>
    </Paper>
  );

  return (
    <>
      {isSmall && (
        <Drawer>
          <DashboardTabs />
        </Drawer>
      )}
      <section className="dashboard mb-4">
        <div className="container dashboard_container">
          <div className="box">
            {!isSmall && (
              <div className="upperBox">
                <div className="row">
                  <div className="col-sm text-center text-sm-start">
                    <h1 style={{ fontWeight: "bolder", color: "white" }}>
                      {grade} - {section}
                    </h1>
                    <h3 style={{ fontWeight: "bolder" }}>
                      {dashboardTab.label}
                    </h3>
                  </div>
                  <div
                    className="col-sm"
                    style={{
                      textAlign: "right",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CurrentDate />
                  </div>
                </div>
                <div className="row"></div>
              </div>
            )}
            {!isSmall && <DashboardTabs />}

            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={dashboardTab.index}
              onChangeIndex={(_, index) => dashboardTab.change(index)}
            >
              <TabPanel
                value={dashboardTab.index}
                index={0}
                dir={theme.direction}
                id="dashboard_assessment_types"
              >
                <Updates />
              </TabPanel>
              <TabPanel
                value={dashboardTab.index}
                index={1}
                dir={theme.direction}
                id="dashboard_assessment_types"
              >
                <Subjects
                  subjects={allSubjects}
                  loading={subLoading}
                  onClick={openSubject}
                />
              </TabPanel>
              <TabPanel
                value={dashboardTab.index}
                index={2}
                dir={theme.direction}
              >
                <AnalyticsTypes displayTopSection={false}></AnalyticsTypes>
              </TabPanel>
              <TabPanel
                value={dashboardTab.index}
                index={3}
                dir={theme.direction}
                id="dashboard_assessment_types"
              >
                <TaskDashboard />
              </TabPanel>
              <TabPanel
                value={dashboardTab.index}
                index={4}
                dir={theme.direction}
                id="dashboard_assessment_types"
              >
                <AssessmentTypes displayTopSection={false} />
              </TabPanel>
            </SwipeableViews>
          </div>
        </div>
      </section>
      {aiStudio ? <ExamModal handleClose={() => setAIStudio(false)} /> : null}
      {mockTest ? <MockExamModal handleClose={() => setMock(false)} /> : null}
    </>
  );
};

export default Dashboard;
